import { useCallback } from 'react'
import { get } from 'aws-amplify/api'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useStringValues() {
  const { state, dispatch } = useAppContext()
  
  const addStringValues = useCallback((bugIndex, stringIndex, value) => {
    dispatch({
      type: actionTypes.ADD_STRING_VALUE,
      bugIndex,
      stringIndex,
      value
    })
  }, [dispatch])
  
  const addBugFieldStringValues = useCallback(() => {
    dispatch({ type: actionTypes.ADD_BUG_FIELD_STRING_VALUES })
  }, [dispatch])
  
  const addStringFieldStringValues = useCallback((bugIndex) => {
    dispatch({
      type: actionTypes.ADD_STRING_FIELD_STRING_VALUES,
      bugIndex
    })
  }, [dispatch])
  
  const removeBugFieldStringValues = useCallback((bugIndex) => {
    dispatch({
      type: actionTypes.REMOVE_BUG_FIELD_STRING_VALUES,
      bugIndex
    })
  }, [dispatch])
  
  const removeStringFieldStringValues = useCallback((bugIndex, stringIndex) => {
    dispatch({
      type: actionTypes.REMOVE_STRING_FIELD_STRING_VALUES,
      bugIndex,
      stringIndex
    })
  }, [dispatch])
  
  const fetchStringValue = useCallback(async (resourceId, bugIndex, stringIndex) => {
    if (!resourceId) {
      dispatch({
        type: actionTypes.FETCH_STRING_VALUE_SUCCESS,
        resource: [],
        bugIndex,
        stringIndex
      })
      return
    }
    
    const sanitizedId = encodeURIComponent(resourceId)
    dispatch({ type: actionTypes.FETCH_STRING_VALUE_START })
    try {
      const { response } = get({
        apiName: 'GetResource',
        path: `resources/${encodeURIComponent(resourceId)}`
      })
      const res = await response
      const data = await res.body.json()
      dispatch({
        type: actionTypes.FETCH_STRING_VALUE_SUCCESS,
        resource: data,
        bugIndex,
        stringIndex
      })
    } catch (error) {
      console.error(error)
      dispatch({ type: actionTypes.FETCH_STRING_VALUE_ERROR })
    }
  }, [dispatch])
  
  return {
    stringValues: state.stringValues,
    addStringValues,
    addBugFieldStringValues,
    addStringFieldStringValues,
    removeBugFieldStringValues,
    removeStringFieldStringValues,
    fetchStringValue
  }
}
